import { type ComponentProps, useState, useEffect } from "react";
import { Button } from "@mui/material";

type DelayedButtonProps = {
	countFrom: number;
	clickHandler: () => void;
	className: string;
	text: string;
	stateHandler?: (state: boolean) => void;
} & ComponentProps<typeof Button>;

export default function DelayedButton({ countFrom, clickHandler, ...props }: DelayedButtonProps) {
	const [counter, setCounter] = useState(countFrom);
	const [isButtonDisabled, setIsButtonDisabled] = useState(true);

	useEffect(() => {
		if (counter > 0) {
			const intervalId = setInterval(() => {
				setCounter((prevCounter) => prevCounter - 1);
			}, 1000);

			return () => clearInterval(intervalId);
		} else {
			props.stateHandler?.(false);
			return setIsButtonDisabled(false);
		}
	}, [counter]);

	const handleClick = () => {
		setCounter(countFrom);
		setIsButtonDisabled(true);
		props.stateHandler?.(true);
		clickHandler();
	};

	return (
		<Button className={props.className} onClick={handleClick} disabled={isButtonDisabled} variant="contained" disableElevation>
			{counter > 0 ? `${props.text} ${counter}s` : `${props.text}`}
		</Button>
	);
}
